import { getCurrentEcosystemBasePath } from '@ice-web-app/shared-utils';
import { Stack, useMediaQuery } from '@mui/material';
import classnames from 'classnames';
import { FC } from 'react';
import { verticalLayoutClasses } from '../../../@layouts/utils/layoutClasses';
import ActionMenu from './ActionMenu';
import { VerticalNavToggle } from './NavToggle';
import ZoneMenu from './ZoneMenu';

interface Props {
  sidebar?: boolean;
}

export const VerticalNavbarContent: FC<Props> = ({ sidebar }) => {
  const isMedium = useMediaQuery('(min-width:500px)');
  const ecosystemBasePath = getCurrentEcosystemBasePath('/innovation');

  return (
    <div
      className={classnames(
        verticalLayoutClasses.navbarContent,
        `flex items-center gap-4 g-lg-0 is-full ${!ecosystemBasePath && 'justify-end'}`,
      )}
    >
      <Stack
        alignItems="center"
        gap={4}
        justifyContent="left"
        flex={sidebar ? 0 : { xs: 0.25, lg: 1 }}
        direction="row"
        {...(!isMedium && { marginLeft: 'auto' })}
      >
        <VerticalNavToggle />
        {/* <ModeDropdown /> */}
      </Stack>
      {isMedium && ecosystemBasePath && <ZoneMenu />}
      <ActionMenu />
    </div>
  );
};
